import actionDispatcher from 'api/actionDispatcher';
import { currentCreditApi } from 'api/billing';
import { getPaymentMethod, getStripeCustomer, setupIntent } from 'api/settings';

import actionType from './actionConstant';

export const currentCreditAction = ({ token, companyUUID }, commonConfig) => {
    return actionDispatcher({
        serviceMethod: currentCreditApi.bind(null, { companyUUID, token }),
        actionTypeSuccess: actionType.GET_CURRENT_CREDIT_SUCCESS,
        actionTypeFailure: actionType.GET_CURRENT_CREDIT_FAILURE,
        actionTypeInProgress: actionType.GET_CURRENT_CREDIT_REQUEST,
        extra: null,
        commonConfig,
        callback: () => {},
    });
};

// Payment Methods
export const paymentMethodsAction = (Data, commonConfig, token, cb) =>
    actionDispatcher({
        serviceMethod: getPaymentMethod.bind(null, Data, token),
        actionTypeSuccess: actionType.PAYMENT_METHOD_SUCCESS,
        actionTypeFailure: actionType.PAYMENT_METHOD_FAILURE,
        actionTypeInProgress: actionType.PAYMENT_METHOD_REQUEST,
        extra: null,
        commonConfig,
        callback: cb,
    });

export const stripeCustomerAction = (Data, commonConfig, token, cb) =>
    actionDispatcher({
        serviceMethod: getStripeCustomer.bind(null, Data, token),
        actionTypeSuccess: actionType.STRIPE_CUSTOMER_SUCCESS,
        actionTypeFailure: actionType.STRIPE_CUSTOMER_FAILURE,
        actionTypeInProgress: actionType.STRIPE_CUSTOMER_REQUEST,
        extra: null,
        commonConfig,
        callback: cb,
    });

export const setupIntentAction = (Data, commonConfig, token, cb) =>
    actionDispatcher({
        serviceMethod: setupIntent.bind(null, Data, token),
        actionTypeSuccess: actionType.SETUP_INTENT_SUCCESS,
        actionTypeFailure: actionType.SETUP_INTENT_FAILURE,
        actionTypeInProgress: actionType.SETUP_INTENT_REQUEST,
        extra: null,
        commonConfig,
        callback: cb,
    });

export const setShowModal = (value) => {
    return {
        type: actionType.SHOW_MODAL,
        payload: value,
    };
};

export const resetGlobalApiStateAction = () => ({
    type: 'global-api/resetApiState',
});
